// Authentication functions - Ad blocker compatible version
import { 
  API_BASE, isSignedIn, currentUser, googleClientId, pendingFeedback, stories, currentCategory,
  setIsSignedIn, setCurrentUser, setGoogleClientId, setPendingFeedback
} from './state.js';
import { getCookie, showToast } from './utils.js';

// Forward declarations - will be set by main.js
let loadStoriesFn = null;
let showBlockModalForStoryFn = null;

export function setAuthDependencies(loadStories, showBlockModalForStory) {
  loadStoriesFn = loadStories;
  showBlockModalForStoryFn = showBlockModalForStory;
}

export async function checkAuthStatus() {
  try {
    const response = await fetch(`${API_BASE}/auth/me`, { credentials: 'include' });
    const data = await response.json();
    if (data.authenticated && data.user) {
      setIsSignedIn(true);
      setCurrentUser(data.user);
      window.googleUserEmail = data.user.email;
      updateAuthUI();
      
      // Check for success message from OAuth callback
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('signin') === 'success') {
        showToast(`Welcome back, ${data.user.name}!`, 'success');
        // Clean up URL
        window.history.replaceState({}, '', '/');
        
        // Reload stories
        if (loadStoriesFn) await loadStoriesFn(currentCategory);
      }
    }
    
    // Check for error from OAuth callback
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    if (error) {
      showToast('Sign in failed. Please try again.', 'error');
      window.history.replaceState({}, '', '/');
    }
  } catch (error) {
    console.error('Error checking auth status:', error);
  }
}

export async function initGoogleSignIn() {
  try {
    const response = await fetch(`${API_BASE}/auth/config`);
    const config = await response.json();

    if (config.googleAuthEnabled && config.clientId) {
      setGoogleClientId(config.clientId);
      console.log('Google OAuth enabled with client ID:', config.clientId);
    } else {
      const signinBtn = document.getElementById('google-signin-btn');
      if (signinBtn) {
        signinBtn.title = 'Sign in coming soon';
        signinBtn.classList.add('btn-coming-soon');
        signinBtn.disabled = true;
        const span = signinBtn.querySelector('span');
        if (span) span.textContent = 'Soon';
      }
    }
  } catch (error) {
    console.error('Error loading auth config:', error);
  }
}

export function updateAuthUI() {
  const signinBtn = document.getElementById('google-signin-btn');
  const userProfile = document.getElementById('user-profile');
  const userAvatar = document.getElementById('user-avatar');
  const userName = document.getElementById('user-name');

  if (isSignedIn && currentUser) {
    if (signinBtn) signinBtn.style.display = 'none';
    if (userProfile) {
      userProfile.style.display = 'flex';
      if (userAvatar) userAvatar.src = currentUser.picture || '';
      if (userName) userName.textContent = currentUser.name?.split(' ')[0] || 'User';
    }
  } else {
    if (signinBtn) signinBtn.style.display = 'flex';
    if (userProfile) userProfile.style.display = 'none';
  }
}

export async function triggerGoogleSignIn() {
  console.log('Triggering Google sign-in with OAuth redirect');
  
  try {
    const response = await fetch(`${API_BASE}/auth/google/url`, { credentials: 'include' });
    const data = await response.json();
    
    if (data.url) {
      // Store pending feedback before redirecting
      if (pendingFeedback) {
        sessionStorage.setItem('pendingFeedback', JSON.stringify(pendingFeedback));
      }
      
      // Full page redirect to Google OAuth
      window.location.href = data.url;
    } else {
      showToast('Sign in error. Please try again.', 'error');
    }
  } catch (error) {
    console.error('Error getting OAuth URL:', error);
    showToast('Sign in error. Please try again.', 'error');
  }
}

export async function signOut() {
  try {
    await fetch(`${API_BASE}/auth/logout`, { method: 'POST', credentials: 'include' });
    setIsSignedIn(false);
    setCurrentUser(null);
    window.googleUserEmail = null;
    
    updateAuthUI();
    showToast('Signed out successfully');
    
    // Reload stories to show anonymous view
    if (loadStoriesFn) await loadStoriesFn(currentCategory);
  } catch (error) {
    console.error('Error signing out:', error);
    showToast('Error signing out', 'error');
  }
}

function closeSigninPrompt() {
  const modal = document.getElementById('signin-prompt-modal');
  if (modal) modal.classList.remove('active');
}

export function skipSignin() {
  closeSigninPrompt();
  setPendingFeedback(null);
}
